import BackDropComponent from "@/components/BackDrop";
import { getCarrierListRequest, getRateListRequest } from "@/redux/actions";
import { Box, Checkbox, Grid, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
const headCells = [
    // {
    //   id: "checkbox",
    //   disablePadding: true,
    //   label: "",
    // },
    {
        id: "channel",
        disablePadding: true,
        label: "Channel",
    },
    {
        id: "productName",
        disablePadding: true,
        label: "Product name",
    },
    {
        id: "categoryHeading",
        disablePadding: true,
        label: "Category heading",
    },
    {
        id: "skuSummary",
        disablePadding: true,
        label: "SKU summary",
    },
    {
        id: "sellingPrice",
        disablePadding: true,
        label: "Selling price",
    },
    {
        id: "hsnCode",
        disablePadding: true,
        label: "HSN code",
    },
    {
        id: "dimensionWeight",
        disablePadding: true,
        label: "Dimension/Weight",
    },
    // {
    //   id: "selectPackage",
    //   disablePadding: true,
    //   label: "Select package",
    // },
];
const EnhancedTableHead = (props) => {
    const { onSelectAllClick, numSelected, rowCount } = props;
    return (React.createElement(TableHead, { sx: {
            p: 1,
            background: "#E5E7EB",
            borderRadius: "16px",
            overflow: "hidden",
        } },
        React.createElement(TableRow, { sx: {
                borderBottom: "1px solid #E7E6EB",
                borderRadius: "16px",
            } }, headCells.map((headCell, index) => (React.createElement(TableCell, { key: headCell.id, align: "left", className: "orderTable_heading_font", padding: "normal" }, headCell.id === "checkbox" ? (React.createElement(Checkbox, { color: "primary", indeterminate: numSelected > 0 && numSelected < rowCount, checked: rowCount > 0 && numSelected === rowCount, onChange: onSelectAllClick, sx: {
                transform: "scale(0.8)",
            }, inputProps: {
                "aria-label": "select all orders",
            } })) : (headCell.label)))))));
};
const RateCardLandingPage = () => {
    //   const [productCatalogueData, setProductCatalogueData] = useState<ProductCatalogue[]>([]);
    const [selectedCarrier, setSelectedCarrier] = React.useState("");
    const [carrierList, setCarrierList] = useState([]);
    const [rateList, setRateList] = useState([]);
    const [tenantId, setTenantId] = React.useState(null);
    const [isBackOpenOpen, setIsBackOpenOpen] = React.useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const getCarrierListState = useSelector((state) => state.getCarrierListReducer);
    const getRateListState = useSelector((state) => state.getCarrierRateReducer);
    React.useEffect(() => {
        const updateTenantId = () => {
            const id = localStorage.getItem("tenantId");
            setTenantId(id);
        };
        updateTenantId();
        window.addEventListener("tenantIdChanged", updateTenantId);
        return () => {
            window.removeEventListener("tenantIdChanged", updateTenantId);
        };
    }, []);
    React.useEffect(() => {
        setIsBackOpenOpen(true);
        const id = localStorage.getItem("tenantId");
        if (tenantId) {
            dispatch(getCarrierListRequest({ tenantId: tenantId }));
        }
    }, [tenantId]);
    React.useEffect(() => {
        setIsBackOpenOpen(true);
        const id = localStorage.getItem("tenantId");
        if (selectedCarrier) {
            dispatch(getRateListRequest({ tenantId: id, carrier: selectedCarrier }));
        }
    }, [selectedCarrier, tenantId]);
    React.useEffect(() => {
        const { CarrierListData, error } = getCarrierListState;
        if (error) {
            if (error instanceof Error) {
                enqueueSnackbar(error.message, { variant: "error" });
            }
            setIsBackOpenOpen(false);
            return;
        }
        if (!CarrierListData) {
            return;
        }
        if (CarrierListData.length === 0) {
            setCarrierList([]);
            setSelectedCarrier("");
            setIsBackOpenOpen(false);
            return;
        }
        setCarrierList(CarrierListData);
        setSelectedCarrier((prev) => prev || CarrierListData[0]);
        setIsBackOpenOpen(false);
    }, [getCarrierListState]);
    React.useEffect(() => {
        if (getRateListState.CarrierRateData) {
            const list = getRateListState.CarrierRateData;
            setRateList(list);
            setIsBackOpenOpen(false);
        }
        else if (getRateListState.error) {
            if (getRateListState.error instanceof Error) {
                enqueueSnackbar(getRateListState.error.message, {
                    variant: "error",
                });
            }
            setIsBackOpenOpen(false);
        }
    }, [getRateListState]);
    const zoneKeys = React.useMemo(() => {
        const zones = new Set();
        rateList.forEach((rate) => {
            Object.keys(rate.zoneRatesResponse || {}).forEach((zone) => zones.add(zone));
        });
        return Array.from(zones);
    }, [rateList]);
    const capitalizeFirstLetter = (value) => value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    return (React.createElement(Grid, { container: true, direction: "column", sx: { p: 5, height: "calc(100vh - 66px)" }, className: "m_background_color" },
        React.createElement(Grid, { item: true, container: true, mb: 2, gap: 2 },
            React.createElement(Grid, null,
                React.createElement(Typography, { sx: {
                        fontFamily: "Poppins",
                        fontSize: "24px",
                        fontWeight: 600,
                        color: "#121114",
                    } }, "Rate Card")),
            React.createElement(Grid, { className: "m_border_grey m_bg_wt", sx: { p: 2 }, item: true, xs: 12, container: true, direction: "row", alignItems: "center", justifyContent: "space-between", padding: 1 },
                React.createElement(Grid, { item: true },
                    React.createElement(Select, { value: selectedCarrier, onChange: (e) => setSelectedCarrier(e.target.value), displayEmpty: true, size: "small", sx: { fontSize: "0.875rem", borderRadius: "4px" } },
                        React.createElement(MenuItem, { value: "", disabled: true }, "Select couriers"),
                        carrierList.map((option, idx) => (React.createElement(MenuItem, { key: idx, value: option },
                            React.createElement(Typography, { variant: "body1", className: "m_font_size_14" }, capitalizeFirstLetter(option)))))))),
            React.createElement(Grid, { sx: { width: "100%", mt: 2 } },
                React.createElement(TableContainer, null,
                    React.createElement(Table, { sx: {
                            minWidth: 750,
                            "& .MuiTableCell-root": {
                                borderBottom: "none",
                                fontFamily: "Poppins",
                            },
                        }, size: "medium" },
                        React.createElement(TableHead, { sx: {
                                p: 1,
                                background: "#F1F1F3",
                                overflow: "hidden",
                            } },
                            React.createElement(TableRow, { sx: {
                                    borderBottom: "1px solid #E7E6EB",
                                } },
                                React.createElement(TableCell, { className: "orderTable_heading_font", align: "left", sx: {
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "12px",
                                        color: "#6B6B6B",
                                    } }, "Service"),
                                React.createElement(TableCell, { className: "orderTable_heading_font", align: "left", sx: {
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "12px",
                                        color: "#6B6B6B",
                                    } }, "Min weight"),
                                zoneKeys.map((zone) => (React.createElement(TableCell, { key: zone, align: "left", className: "orderTable_heading_font", sx: {
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "12px",
                                        color: "#6B6B6B",
                                    } },
                                    React.createElement(Typography, { sx: {
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "12px",
                                            color: "#6B6B6B",
                                            lineHeight: 1.2,
                                        } }, zone),
                                    React.createElement(Typography, { sx: {
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "12px",
                                            color: "#6B6B6B",
                                            lineHeight: 1.2,
                                        } }, "Forward | Additional")))),
                                React.createElement(TableCell, { className: "orderTable_heading_font", align: "left", sx: {
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "12px",
                                        color: "#6B6B6B",
                                    } }, "COD base | COD %"))),
                        React.createElement(TableBody, { sx: { p: 2, mt: 1 } }, rateList.length === 0 ? (React.createElement(TableRow, null,
                            React.createElement(TableCell, { colSpan: zoneKeys.length + 3, align: "center", sx: {
                                    py: 4,
                                    fontFamily: "Poppins",
                                    fontSize: "14px",
                                    color: "#6B6B6B",
                                } }, "No rates available"))) : (rateList.map((rate, idx) => {
                            var _a;
                            return (React.createElement(TableRow, { key: idx, className: "m_bg_wt", hover: true, sx: {
                                    borderBottom: "10px solid #f5f8f8",
                                    "&:last-child": {
                                        borderBottom: "none",
                                    },
                                } },
                                React.createElement(TableCell, { align: "left", sx: {
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "12px",
                                        color: "#4B4B4B",
                                        py: 2,
                                    } }, rate.serviceName),
                                React.createElement(TableCell, { align: "left", sx: {
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "12px",
                                        color: "#4B4B4B",
                                        py: 2,
                                    } },
                                    rate.baseWeightKg,
                                    " kg"),
                                zoneKeys.map((zone) => {
                                    var _a;
                                    const zoneRate = (_a = rate.zoneRatesResponse) === null || _a === void 0 ? void 0 : _a[zone];
                                    return (React.createElement(TableCell, { key: zone, align: "left", sx: { py: 2 } }, zoneRate ? (React.createElement(Box, { sx: { display: "flex", alignItems: "left", gap: 1 } },
                                        React.createElement(Typography, { sx: {
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "12px",
                                                color: "#4B4B4B",
                                            } },
                                            "\u20B9 ",
                                            zoneRate.forwardFreightBaseRate),
                                        React.createElement(Typography, { sx: {
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "12px",
                                                color: "#4B4B4B",
                                            } }, "|"),
                                        React.createElement(Typography, { sx: {
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "12px",
                                                color: "#4B4B4B",
                                            } },
                                            "\u20B9 ",
                                            zoneRate.forwardFreightAdditionalRate))) : (React.createElement(Typography, { sx: {
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "12px",
                                            color: "#4B4B4B",
                                        } }, "NA"))));
                                }),
                                React.createElement(TableCell, { align: "left", sx: {
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "12px",
                                        color: "#4B4B4B",
                                        py: 2,
                                    } },
                                    React.createElement("span", { style: { color: "#4B4B4B", fontWeight: 500 } },
                                        "\u20B9 ",
                                        rate.codBaseRate),
                                    React.createElement("span", { style: { color: "#4B4B4B" } },
                                        " | ",
                                        Number((_a = rate.codPercent) !== null && _a !== void 0 ? _a : 0).toFixed(2),
                                        "%"))));
                        }))))))),
        React.createElement(BackDropComponent, { open: isBackOpenOpen })));
};
export default RateCardLandingPage;
